import { DeviceUiState } from '@/store/modules/deviceUi/types'

export const state: DeviceUiState = {
  interacted: false,
  modifiedDeviceNames: new Map<string, string>(),
  modifiedDeviceIcons: new Map<string, string>(),
}
